import React from 'react';
import logo from './logo.svg';
import './App.css';
import CompensationCalculator from './interactive_calculator';

function App() {
  return (
    <div className="App">
      <CompensationCalculator />
    </div>
  );
}

export default App;
